import { useContext } from "react";

import { AppConfigContext } from "Contexts/AppConfig";

const UseAppConfig = () => {
  const { loadingConfig, appConfig } = useContext(AppConfigContext);

  return {
    loadingConfig,
    appConfig,
  };
};

export default UseAppConfig;
